// Code for generating the narrative using scrollmagic library.

// Get the trigger element for a specified element.
function getTriggerElement(element) {
  var triggerId = `${element.Oid}-trigger`;
  return document.getElementById(triggerId);
}

function getElementContainerId(element) {
  containerId = `${element.Oid}-container`;
  return containerId;
}

function getElement(element) {
  elementId = `${element.Oid}-element`;
  return elementId;
}

function Narrative({ scrollmagic, targetRef, narrative, debugMode }) {
  // Requires three inputs:
  //   @scrollmagic — the scrollmagic instance attached to Vue;
  //   @ targetref — the $ref to the element holding the narrative stream;
  //   @narrative — the object containing all narrative elements.
  this.scaleFactor = targetRef.clientWidth / window.innerWidth;
  this.debugMode = debugMode;
  this.narrative = narrative;
  this.targetRef = targetRef;
  this.$scrollmagic = scrollmagic;
  this.$scrollmagic.attachTo(this.targetRef);
  this.currentBackground = null;
}

Narrative.prototype.reset = function() {
  // Destroys all scenes attached to the target.
  this.targetRef.$scrollmagic.destroy();
};

Narrative.prototype.create = function() {
  // Create the narrative.
  scenes = [];
  this.narrative.elements.forEach((e) => {
    if (e.type == "COLOR") {
      scenes.push(this.colorScene(e));
    }
    if (e.type == "IMAGE" && e.isBackground) {
      scenes.push(this.backgroundImageScene(e));
    }
    if (e.type == "VIDEO" && e.isBackground) {
      scenes.push(this.backgroundImageScene(e));
    }
    if (e.type == "TEXT") {
      scenes.push(this.genericScene(e));
    }
    if (e.type == "IMAGE" && !e.isBackground) {
      scenes.push(this.genericScene(e));
    }
    if (e.type == "VIDEO" && !e.isBackground) {
      scenes.push(this.genericScene(e));
    }
    if (e.type == "AUDIO" && !e.isBackground) {
      scenes.push(this.genericScene(e));
    }
    if (e.pinElement) {
      scenes.push(this.pinScene(e));
    }
  }); // END ELEMENT CREATION LOOP

  // Add all scenes to the local SCROLLMAGIC canvas...
  this.targetRef.$scrollmagic.addScene(scenes);
};

Narrative.prototype.pinScene = function(e) {
  var triggerElement = getTriggerElement(e);
  var containerId = getElementContainerId(e);
  var containerTrigger = document.getElementById(containerId);
  scene = this.$scrollmagic
    .scene({
      triggerElement: containerTrigger,
      triggerHook: e.pinPosition,
      duration: e.pinDuration * this.scaleFactor,
    })
    .setPin(containerTrigger);
  return scene;
};

Narrative.prototype.genericScene = function(e) {
  var triggerElement = getTriggerElement(e);
  var elementId = getElement(e);
  scene = this.$scrollmagic
    .scene({
      triggerElement: triggerElement,
      triggerHook: e.triggerHook,
      duration: e.duration * this.scaleFactor,
    })
    .setTween(`#${elementId}`, 0.5, {
      css: {
        opacity: e.endOpacity,
        left: `${100 * (1 + e.endWidth) * e.endPosition - 100 * e.endWidth}%`,
        width: `${e.endWidth * 100}%`,
        scale: e.endScale,
        marginTop: e.endOffset * this.scaleFactor,
      },
    });
  if (this.debugMode) {
    scene.addIndicators({ name: e.name });
  }
  return scene;
};

// Add background image scene to the document.
Narrative.prototype.backgroundImageScene = function(e) {
  var triggerElement = getTriggerElement(e);
  this.currentBackground = getElementContainerId(e);
  scene = this.$scrollmagic
    .scene({
      triggerElement: triggerElement,
      triggerHook: e.triggerHook,
      duration: e.duration * this.scaleFactor,
    })
    .setTween(`#${this.currentBackground}`, 0.5, {
      css: { opacity: 0.999, zIndex: 100 },
    });
  // .setTween("#narrativeCanvas", 0.5, {
  //   css: { backgroundColor: "transparent" },
  // });

  if (this.debugMode) {
    scene.addIndicators({ name: e.name });
  }
  return scene;
};

// Add background color to the document.
Narrative.prototype.colorScene = function(e) {
  var triggerElement = getTriggerElement(e);
  // var triggerElement = document.getElementById('trigger')
  scene = this.$scrollmagic
    .scene({
      triggerElement: triggerElement,
      triggerHook: e.triggerHook,
      duration: e.duration * this.scaleFactor,
    })
    .setTween("#colorBackground", 0.5, {
      css: { backgroundColor: e.backgroundColor },
    });
  if (this.debugMode) {
    scene.addIndicators({ name: e.name });
  }
  return scene;
};

module.exports = Narrative;
